import { cva } from '@/styled-system/css';

export const calendarDayRecipe = cva({
  base: {
    display: 'grid',
    placeItems: 'center',
    position: 'relative',
    width: 'action.sm',
    height: 'action.sm',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'background-color, box-shadow, border-color',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    transitionTimingFunction: '{easings.ease}',
    focusOutline: true,
    zIndex: {
      base: 1,
      _focusVisible: 2,
    },
    backgroundColor: {
      base: 'bg.action.bare.neutral.default',
    },
    borderColor: {
      base: 'transparent.invisible',
    },
    color: {
      base: 'text.neutral',
    },
    borderStyle: 'solid',
    textStyle: 'body-sm-bold',
    borderRadius: 'shape.ellipse',
  },
  variants: {
    selected: {
      true: {
        borderWidth: 'selected',
      },
      false: {
        borderWidth: 'default',
      },
    },
    today: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        cursor: 'default',
        opacity: '0.6',
        textDecoration: 'line-through',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          _hover: 'bg.action.bare.neutral.hover',
          _active: 'bg.action.bare.neutral.pressed',
        },
        color: {
          _hover: 'text.neutral-fixed',
          _active: 'text.neutral-fixed',
        },
        borderColor: {
          _hover: 'transparent.invisible',
          _active: 'transparent.invisible',
        },
      },
    },
  },
  compoundVariants: [
    {
      selected: false,
      disabled: false,
      css: {
        backgroundColor: {
          _hover: 'bg.action.bare.neutral.hover',
          _active: 'bg.action.bare.neutral.pressed',
        },
        borderColor: {
          _hover: 'transparent.invisible',
          _active: 'transparent.invisible',
        },
        color: {
          _hover: 'text.neutral-fixed',
          _active: 'text.neutral-fixed',
        },
      },
    },
    {
      today: [true, false],
      selected: true,
      disabled: false,
      css: {
        borderColor: {
          base: 'border.action.hero.selected.default',
          _hover: 'border.action.hero.selected.hover',
          _active: 'border.action.hero.selected.pressed',
        },
        backgroundColor: {
          base: 'Calendar.Day.bg.selected',
          _hover: 'Calendar.Day.bg.selectedHover',
          _active: 'Calendar.Day.bg.selectedPressed',
        },
        color: {
          base: 'text.neutral',
          _hover: 'text.neutral',
          _active: 'text.neutral',
        },
      },
    },
    {
      today: true,
      selected: false,
      disabled: false,
      css: {
        borderColor: {
          base: 'border.action.neutral.default',
          _hover: 'border.action.neutral.hover',
          _active: 'border.action.neutral.pressed',
        },
        color: {
          base: 'text.neutral',
          _hover: 'text.neutral-fixed',
          _active: 'text.neutral-fixed',
        },
      },
    },
  ],
});
